<div class='flex flex-row m-0 px-5 items-center w-full'>

  <i class='menu-dashboard-button fa fa-bars relative text-3xl hover:cursor-pointer sm:hidden'
     (click)='openSidenav.emit()'></i>

  <div class="sm:hidden w-full"></div>

  <a class="flex flex-row no-underline items-center"
     [href]='getBlogUrl()'>
    <div class="w-[40px] mr-6">
      <img class="w-full"
           src='/assets/images/128x128/binarycoffee_2.0.0.png'
           alt='binarycoffee-logo'>
    </div>
    <span>Binary Coffee</span>
  </a>

</div>
